import * as React from "react";
const SvgHandicapFailure = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Card-Game-Choose--Streamline-Streamline-3.0",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Card Game Choose Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "card-game-choose"), /* @__PURE__ */ React.createElement("path", {
	d: "m9.75 19.11 -2.879 1.049a1.5 1.5 0 0 1 -1.923 -0.9L0.841 7.988a1.5 1.5 0 0 1 0.9 -1.923L8.25 3.692",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.75 12.75V2.25a1.5 1.5 0 0 0 -1.5 -1.5h-7.5a1.5 1.5 0 0 0 -1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h0.75",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.25 8.25a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17.92 22.7a0.75 0.75 0 0 1 -1.435 0.04L13.3 14.252a0.75 0.75 0 0 1 0.949 -0.949l8.485 3.182a0.75 0.75 0 0 1 -0.04 1.435l-3.909 0.868Z",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgHandicapFailure as ReactComponent };
